import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Main from "./main"

import { setupAxiosInterceptors } from "./utils/axiosInterceptor";
import { BrandingProvider } from "./context/BrandingContext";
setupAxiosInterceptors();


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrandingProvider>
  <BrowserRouter>
    <App />
    {/* <Main/> */}
    {/* <ToastContainer
      position="top-right"
      autoClose={1000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="dark"
      bodyClassName="toastBody"
    /> */}
  </BrowserRouter>
  </BrandingProvider>
);
